/* ============================================================
   OTAKU STUDIOS — Dark JP Theme · theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ---------- MOBILE MENU ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = menu.hasAttribute('hidden') === false;
      if (isOpen) {
        menu.setAttribute('hidden', '');
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      } else {
        menu.removeAttribute('hidden');
        menu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.setAttribute('hidden', '');
        menu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------- SCROLL REVEAL ---------- */
  function initScrollReveal() {
    var targets = document.querySelectorAll(
      '.featured-drop__body, .product-card, .manifesto__content, .newsletter__inner, ' +
      '.collection-tile, .blog-card, .product-page__grid, .cart-item'
    );
    if (!('IntersectionObserver' in window) || !targets.length) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    targets.forEach(function (el) { el.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- PRODUCT GALLERY ---------- */
  function initProductGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return;
    var total = track.children.length;
    if (total < 2) return;

    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var counter = gallery.querySelector('[data-gallery-counter]');
    var main = gallery.querySelector('.product-gallery__main');
    var current = 0;

    function show(i) {
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      current = i;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + total;
      // Pause any playing video when sliding away
      gallery.querySelectorAll('video').forEach(function (v) {
        try { v.pause(); } catch (e) {}
      });
    }

    thumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { show(idx); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(current + 1); });

    // Keyboard arrows (ignored while typing in a field)
    document.addEventListener('keydown', function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
      if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    // Touch swipe on the main image
    if (main) {
      var startX = 0, startY = 0;
      main.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].clientX;
        startY = e.changedTouches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(dx < 0 ? current + 1 : current - 1);
        }
      }, { passive: true });
    }
  }

  /* ---------- VARIANT SELECTOR ---------- */
  function initVariantSelector() {
    var select = document.querySelector('[data-variant-select]');
    if (!select) return;
    var priceEl = document.querySelector('[data-price]');

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt) {
        var p = opt.getAttribute('data-price');
        if (p) priceEl.textContent = p;
      }
      // reflect variant in URL so refresh keeps selection
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', url);
      } catch (e) {}
    });
  }

  /* ---------- AJAX ADD TO CART (cart count refresh) ---------- */
  function initAddToCart() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var button = form.querySelector('[data-add-to-cart]');

    form.addEventListener('submit', function (e) {
      // Only intercept if fetch is available; otherwise fall back to normal submit
      if (!window.fetch) return;
      e.preventDefault();
      var originalText = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.innerHTML = 'Adding…'; }

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add-failed');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (button) {
            button.innerHTML = 'Added ✓';
            setTimeout(function () {
              button.disabled = false;
              button.innerHTML = originalText;
            }, 1600);
          }
        })
        .catch(function () {
          // fallback: hard submit
          form.submit();
        });
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ---------- PRODUCT RECOMMENDATIONS ---------- */
  function initRecommendations() {
    var container = document.querySelector('[data-recommendations]');
    if (!container || !window.fetch) return;
    var url = container.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh) container.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* silent */ });
  }

  /* ---------- STICKY HEADER SHADOW ---------- */
  function initStickyHeader() {
    var header = document.querySelector('.site-header[data-sticky="true"]');
    if (!header) return;
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if (y > 40) {
        header.style.boxShadow = '0 1px 30px rgba(0,0,0,0.6)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = y;
    }, { passive: true });
  }

  /* ---------- EMAIL POPUP ---------- */
  function initEmailPopup() {
    var popup = document.querySelector('[data-email-popup]');
    if (!popup) return;

    var STORAGE_DISMISSED = 'os_popup_dismissed_until';
    var STORAGE_SUBMITTED = 'os_popup_submitted';

    // Already submitted? never show again
    try {
      if (localStorage.getItem(STORAGE_SUBMITTED) === '1') return;
      var dismissedUntil = parseInt(localStorage.getItem(STORAGE_DISMISSED) || '0', 10);
      if (dismissedUntil && Date.now() < dismissedUntil) return;
    } catch (e) { /* localStorage blocked, continue */ }

    var trigger = popup.getAttribute('data-trigger') || 'delay';
    var delayMs = parseInt(popup.getAttribute('data-delay') || '7000', 10);
    var rememberDays = parseInt(popup.getAttribute('data-remember-days') || '14', 10);

    var shownOnce = false;
    function show() {
      if (shownOnce) return;
      shownOnce = true;
      popup.hidden = false;
      popup.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    }
    function hide(remember) {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (remember) {
        try {
          var until = Date.now() + (rememberDays * 24 * 60 * 60 * 1000);
          localStorage.setItem(STORAGE_DISMISSED, String(until));
        } catch (e) {}
      }
    }

    // Triggers
    if (trigger === 'delay') {
      setTimeout(show, delayMs);
    } else if (trigger === 'scroll') {
      var scrollHandler = function () {
        var scrolled = (window.pageYOffset / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrolled >= 40) {
          show();
          window.removeEventListener('scroll', scrollHandler);
        }
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
    } else if (trigger === 'exit') {
      var exitHandler = function (e) {
        if (e.clientY < 10) {
          show();
          document.removeEventListener('mouseleave', exitHandler);
        }
      };
      document.addEventListener('mouseleave', exitHandler);
      // Also fall back to delay for mobile (no exit intent)
      setTimeout(show, 25000);
    }

    // Close buttons
    var closeBtns = popup.querySelectorAll('[data-popup-close], [data-popup-overlay]');
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { hide(true); });
    });
    // ESC
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) hide(true);
    });

    // AJAX form submit
    var form = popup.querySelector('#email-popup-form');
    var successJs = popup.querySelector('[data-popup-success-js]');
    var content = popup.querySelector('[data-popup-content]');

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // fall back to native submit
        e.preventDefault();
        var submitBtn = form.querySelector('.email-popup__submit');
        var origText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Saving…'; }

        var fd = new FormData(form);
        fetch(window.location.pathname, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'text/html' }
        })
          .then(function () {
            // Show success state (regardless of server response — Shopify customer form
            // returns full page HTML which we don't parse; assume optimistic success)
            try { localStorage.setItem(STORAGE_SUBMITTED, '1'); } catch (e) {}
            if (successJs) {
              form.style.display = 'none';
              successJs.hidden = false;
            } else {
              if (submitBtn) submitBtn.textContent = 'Submitted ✓';
            }
          })
          .catch(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = origText; }
          });
      });
    }

    // Copy code button
    popup.querySelectorAll('[data-popup-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            btn.classList.add('is-copied');
            var orig = btn.textContent;
            btn.textContent = 'Copied ✓';
            setTimeout(function () {
              btn.classList.remove('is-copied');
              btn.textContent = orig;
            }, 1800);
          });
        }
      });
    });

    // If server-rendered success state is present (e.g. user submitted, page reloaded),
    // mark submitted in storage so we don't show popup again on next visit.
    if (popup.querySelector('[data-popup-success-server]')) {
      try { localStorage.setItem(STORAGE_SUBMITTED, '1'); } catch (e) {}
      // Also auto-show the popup so they see their code
      show();
    }
  }

  /* ---------- INIT ---------- */
  function init() {
    initMobileMenu();
    initScrollReveal();
    initProductGallery();
    initVariantSelector();
    initAddToCart();
    initRecommendations();
    initStickyHeader();
    initEmailPopup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
